var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-pannel"},[(_vm.title)?_c('h2',{staticClass:"pannel-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"pannel-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }